define(['jquery', 'forms', 'masking'], function ($, Forms, Masking) {

		var YearlyProduct = function() {
			var self = this;

			self.forms = new Forms();
			self.$ervBody = $('#erv-body');

			self.setCountryDayValidation = function($container) {
				var isSet = false;
				var $daysAreSet = $container.find('#Input_DaysAreSet');

				$container.find('.numbersonly').each(function() {
					if (Number($(this).val()) > 0) {
						isSet = true;
					}
				});

				$daysAreSet.val(isSet);
			}

			self.initAtLeastOneCountryDaySet = function() {
				var $daysAreSet = self.$ervBody.find('#Input_DaysAreSet'),
					$container = $daysAreSet.parent();

				$container.on('input propertychange paste',
					'.numbersonly',
					function() {
						self.setCountryDayValidation($container);
					});
			};
			self.$ervBody.find('[data-js = "maskingCVRNumber"]').on('input', function () {
				Masking.MaskingCVRNumber(this, document.documentElement.getAttribute('data-domain'));
			});
		};

		YearlyProduct.prototype.init = function() {
			var self = this;
			self.initAtLeastOneCountryDaySet();

			var $button = self.$ervBody.find('.next-step');
			$button.on('click', function (e) {
				if (!$button.parents('form').valid()) {
					e.preventDefault();
					e.stopPropagation();
				}
			});
		}
	

	return YearlyProduct;
});